import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { getLocalProductLevel, getUserData, setLocalProductLevel } from "../utils/localStorage";
import { getProductLevel } from "../services/userMasterUser";

const DashboardOperation = () => {
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const { userProfileData } = getUserData();

  const toggleFilter = () => {
    setIsFilterVisible(!isFilterVisible);
  };

   const [productsLevelList, setProductsLevelList] = useState()

   useEffect(() => {
       fetchProductLevel()
       fetchLocalProductLevel()
   
     }, [])
   
     const productLevelDataApi = {
       searchBy: "",
       searchText: "",
       limit: 100000,
       offset: 0,
       sortBy: "",
       sortOrder: "desc",
       statusIn: [],
       productIdIn: [],
       productLevelIn: userProfileData?.userTypeInfo?.split(",").map(item => item.trim())

     };
   
   
     const fetchProductLevel = async () => {
       try {
         const response = await getProductLevel(productLevelDataApi);
         if (!response.data.error) {
           const newData = response.data.data || response.data; // adjust if API structure differs
           setLocalProductLevel(newData);
         }
       } catch (err) {
         console.error("Error:", err);
       }
     };
   
     const fetchLocalProductLevel = async () => {
       const { productLevel } = getLocalProductLevel();
       if (productLevel && Object.keys(productLevel).length > 0) {
         setProductsLevelList(productLevel);
       } else {
         await fetchProductLevel();
       }
     };
     

  return (
    <main id="main" className="main">
      <section className="section dashboard">
        <div className="row">
          {/* Left side columns */}
          <div className="col-lg-12">
            <div className="row">
              {/* Sales Card */}
              <div className=" col-md-12">
                <div className="card info-card sales-card">
                  <div className="card-body">
                    <div
                      style={{
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h5 className="card-title">
                        Operation Team Dashboard <span>| Financeseva</span>
                      </h5>
                      <i
                        className="pi pi-filter-fill"
                        onClick={toggleFilter}
                        style={{ color: "#1e439b" }}
                      ></i>
                    </div>
                    <div className="row">
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501" }}>
                            <h3 className="m-0">
                              <i className={"bi bi-box"} />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                Lead Box
                              </span>
                            </h3>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default DashboardOperation;
